import api from './api';

const list = async (conversationId, params = {}) => {
  const { data } = await api.get(`/messages/${conversationId}`, { params });
  return data;
};

const create = async (conversationId, payload) => {
  const { data } = await api.post(`/messages/${conversationId}`, payload);
  return data;
};

const markRead = async (conversationId) => {
  const { data } = await api.post(`/messages/${conversationId}/read`);
  return data;
};

const messageService = { list, create, markRead };
export default messageService;
